<script>
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import reviewsLogo from './images/reviewsio-logo.svg';
	import Rating from './Rating.svelte';

	let { title, rating, average, total } = $props();
</script>

<div class="content-grid">
	<div
		class="bubble-arrow
		bg-indow-white text-indow-grey-dark relative mb-10
		w-full rounded-lg px-4 py-5"
	>
		<div
			class="flex w-full flex-row flex-wrap items-center justify-between gap-8"
		>
			<div class="grow">
				<div class="flex flex-col gap-2 sm:flex-row sm:items-center">
					<h3
						class="text-indow-grey-dark m-0 w-auto p-0 text-left text-xl font-normal uppercase"
					>
						{title}
					</h3>
					<Rating stars="5" {rating} hideMetaData />
				</div>
				<div class="text-indow-grey-dark mt-2 flex flex-row gap-3">
					<p class="m-0 w-auto text-left">
						{average}
						<span class="text-indow-grey">Average</span>
						<span class="text-indow-grey sr-only relative">Rating</span>
					</p>
					<p class="m-0 w-auto text-left">
						{total}
						<span class="!text-indow-grey">Reviews</span>
					</p>
				</div>
			</div>
			<div class="grow text-end">
				<a
					href="https://www.reviews.io/company-reviews/store/indow1?utm_source=indow1&utm_medium=widget&utm_campaign=carousel"
					target="_blank"
					rel="noreferrer"
					class="inline-block w-full max-w-44"
				>
					<Image src={reviewsLogo} alt="Reviews.io logo" loading="lazy" />
				</a>
			</div>
		</div>
	</div>
</div>

<style>
	.bubble-arrow::after {
		content: '';

		position: absolute;
		bottom: -1rem;
		left: 0;
		transform: translateX(-50%);
		margin-left: 50%;
		width: 0;
		height: 0;
		border-left: 0.75rem solid transparent;
		border-right: 0.75rem solid transparent;
		border-top: 1rem solid white;
	}
</style>
